import { Button, DatePicker, Table } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import { alarmApi } from 'api/alarmApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import {
  selectInverterItemSidebar,
  selectPlantItemSidebar,
} from 'components/Common/Sidebar/sidebarSlice';
import { selectUserInfo } from 'components/Layout/homeSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import { ListResponse } from 'models';
import { alarmcustomize, alarmInfo, originator, statusAlarm } from 'models/alarm';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CgSortAz } from 'react-icons/cg';
import { formatDatatable } from 'utils/common';
import { alarmActions, selectAlarmLoading } from '../../alarmSlice';
import NotificationAlarm from '../NotificationAlarm/NotificationAlarm';
import style from './TableAlarm.module.scss';
export interface TableDetailProps {
  typeAlarm: string;
  alarmList: alarmInfo[];
  valueAlarm: statusAlarm;
  setValueAlarm: (object: statusAlarm) => void;
  setAlarmList: (object: ListResponse<alarmInfo>) => void;
  numberPage: number;

  rangeTime: string[];
  setRangeTime: (array: string[]) => void;
}
export default function TableDetail({
  typeAlarm,
  alarmList,

  valueAlarm,
  setValueAlarm,
  setAlarmList,
  numberPage,

  rangeTime,
  setRangeTime,
}: TableDetailProps) {
  const dispatch = useAppDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const inverterItemSelected = useAppSelector(selectInverterItemSidebar);
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const loading = useAppSelector(selectAlarmLoading);
  const [isNotification, setIsNotification] = useState(false);
  const [dataTable, setDataTable] = useState<alarmcustomize[]>();
  const [clearLoading, setClearLoading] = useState<boolean>(false);
  const [acKnowLoading, setAcKnowLoading] = useState<boolean>(false);
  const isDisable = useAppSelector(selectIsDisable);
  const userInfo = useAppSelector(selectUserInfo);

  const columns = [
    {
      title: 'Created time',
      dataIndex: 'start_ts',
      render: (number: number, record: alarmInfo) => (
        <div
          className={clsx(style.start_ts, {
            [style.unack]: !record.acknowledged === true,
          })}
        >
          {moment(number).format('YYYY-MM-DD HH:mm:ss')}
        </div>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      render: (text: string, record: alarmInfo) => (
        <div
          className={clsx(style.style_default, {
            [style.unack]: !record.acknowledged === true,
          })}
        >
          {text}
        </div>
      ),
    },
    {
      title: 'Originator',
      dataIndex: 'originator',
      render: (object: originator, record: alarmInfo) => (
        <div
          className={clsx(style.originator, {
            [style.unack]: !record.acknowledged === true,
          })}
        >
          {object.entity_name}
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'active',
      render: (value: boolean, record: alarmInfo) => (
        <div
          className={clsx(style.originator, {
            [style.originator_active]: value === true,
            [style.originator_cleared]: value === false,
            [style.unack]: !record.acknowledged === true,
          })}
        >
          {value ? 'ACTIVE' : 'CLEARED'}
        </div>
      ),
    },
    {
      title: 'Severity',
      dataIndex: 'severity',
      render: (text: string, record: alarmInfo) => (
        <div
          className={clsx(style.severity, {
            [style.severity_critical]: text.indexOf('CRITICAL') !== -1,
            [style.severity_warning]: text.indexOf('WARNING') !== -1,
            [style.unack]: !record.acknowledged === true,
          })}
        >
          {text}
        </div>
      ),
    },
  ];
  useEffect(() => {
    setDataTable(formatDatatable(alarmList));
  }, [alarmList]);

  useEffect(() => {
    if (loading) {
      (async () => {
        const response: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
          type_Filter: typeAlarm,
          id:
            typeAlarm === 'ASSET'
              ? plantItemSelected
              : typeAlarm === 'DEVICE'
              ? inverterItemSelected
              : userInfo?.id,
          // start_ts: moment(date_Filter).valueOf(),
          // end_ts: moment(moment(moment(date_Filter).add(1, 'M')).format('YYYY-MM')).valueOf(),
          start_ts: moment(rangeTime[0]).startOf('days').valueOf(),
          end_ts: moment(rangeTime[1]).endOf('days').valueOf(),

          severity: valueAlarm.severity,
          active_or_cleared: valueAlarm.active_or_cleared,
          acknowledged_or_unacknowledged: valueAlarm.acknowledged_or_unacknowledged,
          _limit: 20,
          _page: numberPage,
        });
        setAlarmList(response);
        setSelectedRowKeys([]);
        setClearLoading(false);
        setAcKnowLoading(false);
        dispatch(alarmActions.fetchDataReset);
      })();
    }
  }, [loading]);

  const ClearAlarm = async () => {
    dispatch(alarmActions.fetchPropertiesAlarm({ type: 'clear', array: selectedRowKeys }));
    setClearLoading(true);
  };

  const AcknowledgeAlarm = async () => {
    setAcKnowLoading(true);
    dispatch(alarmActions.fetchPropertiesAlarm({ type: 'ack', array: selectedRowKeys }));
  };

  const onSelectChange = (selectedRowKeys: any) => {
    console.log(
      'Log: ~ file: Table.tsx ~ line 128 ~ onSelectChange ~ selectedRowKeys',
      selectedRowKeys
    );
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  // const onChangeDatePicker = async (date: moment.Moment | null) => {
  //   const month: string = moment(date).format('YYYY-MM');
  //   setDateFilter(month);
  //   const response: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
  //     type_Filter: typeAlarm,
  //     id: typeAlarm === 'ASSET' ? plantItemSelected : inverterItemSelected,
  //     start_ts: moment(month).valueOf(),
  //     end_ts: moment(moment(moment(month).add(1, 'M')).format('YYYY-MM')).valueOf(),
  //     severity: valueAlarm.severity,
  //     active_or_cleared: valueAlarm.active_or_cleared,
  //     acknowledged_or_unacknowledged: valueAlarm.acknowledged_or_unacknowledged,
  //     _limit: 20,
  //     _page: numberPage,
  //   });
  //   setAlarmList(response);
  // };

  const getFilterAlarm = async () => {
    const response: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
      type_Filter: typeAlarm,
      id:
        typeAlarm === 'ASSET'
          ? plantItemSelected
          : typeAlarm === 'DEVICE'
          ? inverterItemSelected
          : userInfo?.id,
      start_ts: moment(rangeTime[0]).startOf('days').valueOf(),
      end_ts: moment(rangeTime[1]).endOf('days').valueOf(),
      // start_ts: moment(date_Filter).valueOf(),
      // end_ts: moment(moment(moment(date_Filter).add(1, 'M')).format('YYYY-MM')).valueOf(),
      severity: valueAlarm.severity,
      active_or_cleared: valueAlarm.active_or_cleared,
      acknowledged_or_unacknowledged: valueAlarm.acknowledged_or_unacknowledged,
      _limit: 20,
      _page: numberPage,
    });
    setAlarmList(response);
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';

  const onChange: RangePickerProps['onChange'] = async (dates, dateStrings) => {
    console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    setRangeTime(dateStrings);
    const response: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
      type_Filter: typeAlarm,
      id:
        typeAlarm === 'ASSET'
          ? plantItemSelected
          : typeAlarm === 'DEVICE'
          ? inverterItemSelected
          : userInfo?.id,
      start_ts: moment(dateStrings[0]).startOf('day').valueOf(),
      end_ts: moment(dateStrings[1]).endOf('day').valueOf(),
      // id: typeAlarm === 'ASSET' ? plantItemSelected : inverterItemSelected,
      // start_ts: moment(month).valueOf(),
      // end_ts: moment(moment(moment(month).add(1, 'M')).format('YYYY-MM')).valueOf(),
      severity: valueAlarm.severity,
      active_or_cleared: valueAlarm.active_or_cleared,
      acknowledged_or_unacknowledged: valueAlarm.acknowledged_or_unacknowledged,
      _limit: 20,
      _page: numberPage,
    });
    setAlarmList(response);
  };

  return (
    <div className={style.table}>
      <div className={style.header_table}>
        <div className={style.group_btn}>
          <Button
            size="small"
            type="primary"
            disabled={isDisable}
            onClick={ClearAlarm}
            loading={clearLoading}
            className={clsx(style.button, {
              [style.hidden]: !hasSelected === true,
            })}
          >
            Clear
          </Button>
          <Button
            size="small"
            type="primary"
            disabled={isDisable}
            onClick={AcknowledgeAlarm}
            loading={acKnowLoading}
            className={clsx(style.button, {
              [style.hidden]: !hasSelected === true,
            })}
          >
            Acknowledge
          </Button>
        </div>
        <div className={style.label_table}>Alarm Table</div>
        <div className={style.total_alarm}>
          {/* <DatePicker
            picker="month"
            defaultValue={moment(date_Filter)}
            onChange={onChangeDatePicker}
            style={{ backgroundColor: '#000', border: 'none' }}
          /> */}
          <div className={style.selected_time}>
            <RangePicker
              style={{ backgroundColor: '#4fd20f', border: 'true' }}
              defaultValue={[moment().subtract(30, 'days'), moment()]}
              format={dateFormat}
              onChange={onChange}
              ranges={{
                'Last 30 days': [moment().subtract(30, 'days'), moment()],
                'Last 90 days': [moment().subtract(90, 'days'), moment()],
                'Last month': [
                  moment().subtract(1, 'M').startOf('month'),
                  moment().subtract(1, 'M').endOf('month'),
                ],
                ' Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                Today: [moment(), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
              }}
            />

            {/* <DateTimePick /> */}
          </div>
          <div className={style.dropdown} onClick={() => setIsNotification(!isNotification)}>
            <CgSortAz
              style={{
                fontSize: '40px',
                cursor: 'pointer',
              }}
            />
            <NotificationAlarm
              isNotification={isNotification}
              valueAlarm={valueAlarm}
              setValueAlarm={setValueAlarm}
              getFilterAlarm={getFilterAlarm}
            />
          </div>
        </div>
      </div>
      <div className={style.table_alarm}>
        <Table
          rowSelection={{ ...rowSelection }}
          columns={columns}
          dataSource={dataTable}
          pagination={false}
          scroll={{ y: 'calc(100vh - 280px)' }}
        ></Table>
      </div>
    </div>
  );
}
